var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('multiple-select-input-field',{attrs:{"value":_vm.mappedValue,"options":_vm.zoneOptions,"disabled":_vm.disabled,"id":"zones","placeholder":"Ziel hinzufügen"},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }